import React from "react";
import { useCookies as reactUseCookies } from "react-cookie";

import { getSiteDomain } from "@/utils/site";
import { setAuthCookie } from "@/services/CookiesService";

import { GlobalContext } from "@/contexts/GlobalContext";
import { GlobalContextProps } from "@/contexts/GlobalContext/types";

import { AUTHORIZATION } from "@/internals/constants/cookies";

import { UtmInterface } from "./types";

const registerAuthCookie = (
  token: string,
  expirationDate: string,
  globalContext: GlobalContextProps
) => {
  setAuthCookie(token, new Date(expirationDate));
  globalContext?.setAuthCookie(AUTHORIZATION, token, {
    domain: `.${getSiteDomain()}`,
    path: "/",
    expires: new Date(expirationDate),
  });
};

const removeAuthCookie = (globalContext: GlobalContextProps) => {
  globalContext?.removeCookie(AUTHORIZATION, { path: "/" });
};

const getAuthCookie = (globalContext: GlobalContextProps) => {
  return globalContext.authCookie?.Authorization;
};

const getUtmsCookie = (utms: UtmInterface) => utms;

export const useCookies = () => {
  const globalContext = React.useContext(GlobalContext);
  const [utmsCookie, removeUtmsCookie] = reactUseCookies(["utms"]);

  return {
    registerAuthCookie: (token: string, expirationDate: string) =>
      registerAuthCookie(token, expirationDate, globalContext),
    removeAuthCookie: () => removeAuthCookie(globalContext),
    getAuthCookie: () => getAuthCookie(globalContext),
    getUtmsCookie: () => getUtmsCookie(utmsCookie.utms),
    removeUtmsCookie: () => removeUtmsCookie("utms", { path: "/" }),
  };
};
